/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElInputNumber as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/input-number/style/css';
import { ElInput as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElSelect as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import __unplugin_components_2 from '/Users/liao/work/cmge/ultrasdk/ultrasdk.hub.web/packages/base/src/components/GameChannelSelect/index.vue';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElDatePicker as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/date-picker/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
import dayjs from 'dayjs';
import { apiUsdkGetPayType } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  __name: 'searchForm',
  props: {
    gid: {
      type: Number,
      default: 0
    }
  },
  emits: ['search'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const props = __props;
    const filter = ref({
      gid: props.gid,
      date: [dayjs().subtract(7, 'days').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
      cid: '',
      payType: '',
      uid: '',
      suid: '',
      roleId: '',
      roleName: '',
      hgOrderNo: '',
      thirdOrderNo: '',
      deviceId: '',
      status: '',
      noticeStatus: '',
      payAmountStart: '',
      payAmountEnd: '',
      moneyMin: 0
    });
    const payType = ref([]);
    const getPayType = () => {
      apiUsdkGetPayType().then(res => {
        if (res.code === 0) {
          payType.value = res.data;
        }
      });
    };
    const handleSearch = () => {
      if (!filter.value.payAmountStart && !filter.value.payAmountEnd) {
        delete filter.value.payAmountStart;
        delete filter.value.payAmountEnd;
      }
      if (filter.value.payAmountEnd && filter.value.payAmountStart > filter.value.payAmountEnd) {
        ElMessage.error('金额限制区间最小值不能大于最大值');
        return;
      }
      emits('search', filter.value);
    };
    onMounted(() => {
      getPayType();
    });
    return (_ctx, _cache) => {
      const _component_el_date_picker = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_GameChannelSelect = __unplugin_components_2;
      const _component_el_option = __unplugin_components_3;
      const _component_el_select = __unplugin_components_4;
      const _component_el_input = __unplugin_components_5;
      const _component_el_input_number = __unplugin_components_6;
      const _component_el_button = __unplugin_components_7;
      const _component_el_form = __unplugin_components_8;
      return _openBlock(), _createBlock(_component_el_form, {
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "下单时间"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: _unref(filter).date,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).date = $event),
            type: "daterange",
            "range-separator": "至",
            "start-placeholder": "开始时间",
            "end-placeholder": "结束时间"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "渠道"
        }, {
          default: _withCtx(() => [_createVNode(_component_GameChannelSelect, {
            disabled: !_unref(filter).gid,
            gid: _unref(filter).gid,
            otherProps: {
              isGlobal: 1
            },
            modelValue: _unref(filter).cid,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(filter).cid = $event)
          }, null, 8, ["disabled", "gid", "modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "支付方式"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            clearable: "",
            modelValue: _unref(filter).payType,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(filter).payType = $event),
            placeholder: "请选择支付方式"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(payType), (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                value: item.key,
                label: item.value
              }, null, 8, ["value", "label"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "UltraSDKID"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(filter).uid,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(filter).uid = $event),
            placeholder: "请输入UltraSDKID"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "角色账号ID"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(filter).suid,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(filter).suid = $event),
            placeholder: "请输入角色账号ID"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "游戏角色ID"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(filter).roleId,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(filter).roleId = $event),
            placeholder: "请输入游戏角色ID"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "游戏角色名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(filter).roleName,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(filter).roleName = $event),
            placeholder: "请输入游戏角色名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Ultra订单号"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(filter).hgOrderNo,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(filter).hgOrderNo = $event),
            placeholder: "请输入Ultra订单号"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "第三方订单"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(filter).thirdOrderNo,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(filter).thirdOrderNo = $event),
            placeholder: "请输入第三方订单"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "设备号"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(filter).deviceId,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(filter).deviceId = $event),
            placeholder: "请输入设备号"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "支付状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(filter).status,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(filter).status = $event),
            clearable: "",
            placeholder: "请选择支付状态"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              value: 0,
              label: "支付成功"
            }), _createVNode(_component_el_option, {
              value: 1,
              label: "支付失败"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "同步状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(filter).noticeStatus,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(filter).noticeStatus = $event),
            clearable: "",
            placeholder: "请选择同步状态"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              value: 0,
              label: "同步成功"
            }), _createVNode(_component_el_option, {
              value: 1,
              label: "同步失败"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "金额限制区间"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: _unref(filter).payAmountStart,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(filter).payAmountStart = $event),
            style: {
              "width": "30%"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_input_number, {
            modelValue: _unref(filter).payAmountEnd,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(filter).payAmountEnd = $event),
            style: {
              "width": "30%"
            }
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: handleSearch,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
});